import script from "./ReportingSearchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportingSearchPage.vue?vue&type=script&setup=true&lang=js"

import "./ReportingSearchPage.vue?vue&type=style&index=0&id=55becedf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55becedf"]])

export default __exports__